module.exports = __webpack_public_path__ + "static/media/profile_18.9c908a1b.jpg";